/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import _ from "lodash"
import { observer } from "mobx-react-lite"
import moment from "moment"
import { IBoxProps, Icon, Modal, ScrollView, Spinner, View } from "native-base"
import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import { Appearance, FlatList, Linking, ListRenderItem, RefreshControl, TouchableOpacity, ViewStyle, useWindowDimensions } from "react-native"
import {
  Image,
  FormControl,
  FormControlProps,
  ModelPicker,
  ModelPickerProps,
  Screen,
  Text,
  JalaLoading,
  Button,
  JalaIcon,
  JalaWebView,
  Actionsheet,
  BetaIcon,
  ListNetworkError,
} from "../../../components"
import { Cycle, Farm, Pond } from "../../../database"
import { translate, TxKeyPath } from "../../../i18n"
import { useStores } from "../../../models"
import { FarmStoreModel } from "../../../models/app-store/farm-store/farm-store"
import { PondStoreModel } from "../../../models/app-store/farm-store/pond-store/pond-store"
import { color } from "../../../theme"
import { delay } from "../../../utils/delay"
import { Source } from "react-native-fast-image"
import Octicons from "react-native-vector-icons/Octicons"
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"
import { navigate } from "../../../navigators"
import { IViewProps } from "native-base/lib/typescript/components/basic/View/types"
import Ionicons from "react-native-vector-icons/Ionicons"
import config from "../../../utils/config"
import JalaAnalytic from "../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flex: 1,
}

const FORM_DROPDOWN: ViewStyle = {
  paddingHorizontal: 16,
  marginBottom: 8
}

const POND_CONTAINER: ViewStyle = {
  flexDirection: 'row',
}

const IMAGE = {
  resizeMode: "contain",
  width: 150,
  height: 150,
  marginTop: 30
}

const IMAGE_NETWORK_ERROR = {
  height: 100,
  width: 100
}

const EMPTY_IMAGE = {
  resizeMode: "contain",
  width: 210,
  height: 150,
  marginTop: 30
}

const COMPLETE_DATA_BUTTON = {
  marginTop: 22,
  marginBottom: 30,
}

const OK_DATA_BUTTON = {
  width: 120,
  height: 36,
  marginTop: 22,
  marginBottom: 16,
  borderRadius: 38
}

const CLOSE_DATA_BUTTON = {
  width: 120,
  height: 36,
  marginTop: 22,
  marginBottom: 16,
  marginRight: 15,
  borderRadius: 38
}

const LIST_PARAMETER_BETA: Array<Array<TxKeyPath | undefined>> = [
  [
    "chemicalParameterScreen.alkalinity",
    "chemicalParameterScreen.carbonate",
    "chemicalParameterScreen.bicarbonate",
  ],
  [
    "chemicalParameterScreen.hardness",
    "chemicalParameterScreen.calcium",
    "chemicalParameterScreen.hardness",
  ],
  [
    "chemicalParameterScreen.ammonia",
    "chemicalParameterScreen.nitrate",
    "chemicalParameterScreen.nitrite",
  ],
  [
    "chemicalParameterScreen.tom",
    undefined,
    undefined,
    undefined,
  ]
]

const emptyPond = require("../activity/cycle-to-do-list/empty-pond.png")
const emptyFarm = require("../activity/cycle-to-do-list/empty-farm.png")
const imageDefault = require("../activity/cycle-to-do-list/empty-search.png")
const imageGotoProAccount = require("./goto-pro-account.png")
const imageBetaTesterEn = require("./beta-tester-en.png")
const imageBetaTesterId = require("./beta-tester-id.png")
const emptyPicker = require("./dropdown-empty.png")

const EmptyPicker: FC<{colorScheme?: "light" | "dark"}> = (props) => {
  const {colorScheme} = props
  return (
    <View
      justifyContent="center" alignItems="center"
    >
      <Image source={emptyPicker} style={IMAGE} />
      <Text
        tx="monitoring.empty"
        preset="title3" textAlign="center" color={color.palette.gray900} colorScheme={colorScheme} />
    </View>
  )
}

const ModelField = (
  { name, colorScheme, formControlProps, modelPickerProps }:
  { name?: string, colorScheme?: "light" | "dark", formControlProps?: FormControlProps, modelPickerProps?: (Omit<ModelPickerProps, "onValueChange"> & { onValueChange?: (value, index, item) => void }) },
) => {
  const dimentions = useWindowDimensions()
  return (
    <FormControl
      labelTx={`waterQualityMultiMeasurementForm.${_.camelCase(name)}` as TxKeyPath}
      colorScheme={colorScheme}
      labelColor={color.palette.gray800}
      style={FORM_DROPDOWN}
      {...formControlProps}
    >
      <ModelPicker
        colorScheme={colorScheme}
        placeholderTx={`waterQualityMultiMeasurementForm.${_.camelCase(name)}Placeholder` as TxKeyPath}
        pickerActionsheetProps={{
          flatListProps: {
            ListEmptyComponent: <EmptyPicker colorScheme={colorScheme} />
          },
          actionsheetStyle: {
            minHeight: dimentions.height / 2,
          }
        }}
        {...modelPickerProps}
      />
    </FormControl>
  )
}

const EmptyHistoryParameterState: FC<{
  colorScheme: "light" | "dark",
  image?: number | Source,
  titleTx?: TxKeyPath,
  messageTx?: TxKeyPath,
  buttonTx?: TxKeyPath,
  withBackground?: boolean,
  onPressButton?: () => void
}& IViewProps> = (props) => {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    onPressButton, withBackground = true,
    titleTx, messageTx, buttonTx, image,
    ...restProps
  } = props;

  const dimensions = useWindowDimensions()

  return (
    <View
      marginTop="16px" marginX="10px" borderRadius={withBackground ? "4px" : "0px"}
      {...withBackground ? {shadow: 1, marginBottom: 1} : {}}
      justifyContent="center" alignItems="center"
      background={withBackground && colorScheme === "light" ? color.palette.white : undefined}
      {...restProps}
    >
      <Image resizeMode="contain" source={image || imageDefault} style={{...EMPTY_IMAGE, width: dimensions.width - 100, height: dimensions.height/4}} />
      <Text
        tx={titleTx || "chemicalParameterScreen.emptyHistoryParameterTitle"} marginTop="16px"
        preset="title3" textAlign="center" color={color.palette.gray900} colorScheme={colorScheme}
        paddingX="20px" />
      {messageTx && <Text
        tx={messageTx}
        paddingTop="8px" paddingX="20px"
        preset="body2" textAlign="center" color={color.palette.gray900} colorScheme={colorScheme} />}
      <Button
        onPress={onPressButton} style={COMPLETE_DATA_BUTTON} textPreset="title4"
        tx={buttonTx || "chemicalParameterScreen.completeData"} colorScheme={colorScheme}
      />
    </View>
  )
}

const EmptyState: FC<{colorScheme: "light" | "dark"}> = observer((props) => {
  const { colorScheme, ...rest } = props

  const { appStore: { farmStore }, chemicalPredictionsStore: { data }, userStore: {userLocale} } = useStores();
  const { pondStoreModels, pondStore } = farmStore || FarmStoreModel.create({});

  const [ emptyKey, setEmptyKey ] = useState<string>('farm')

  const content = {
    farm: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyFarm', testID: 'jala:id/create-farm', button: 'pondScreen.addFarm' as TxKeyPath, img: emptyFarm, useBackgroud: false },
    pond: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyPond', testID: 'jala:id/create-pond', button: 'pondScreen.addPond' as TxKeyPath, img: emptyPond, useBackgroud: false },
    cycle: { title: 'cycleToDoScreen.empty', subtitle: 'chemicalParameterScreen.emptyCycle', testID: 'jala:id/create-cycle', button: 'pondScreen.startCycle' as TxKeyPath, img: emptyPond, useBackgroud: false },
    emptyHistory: { title: 'chemicalParameterScreen.emptyHistoryParameterTitle', subtitle: 'chemicalParameterScreen.emptyHistoryParameterMessage', testID: 'jala:id/create-cycle', button: 'chemicalParameterScreen.completeData' as TxKeyPath, img: imageDefault, useBackgroud: true },
    nonPro: { title: 'chemicalParameterScreen.gotoProTitle', testID: 'jala:id/create-cycle', button: 'chemicalParameterScreen.buttonGotoPro' as TxKeyPath, img: userLocale === 'id' ? imageBetaTesterId : imageBetaTesterEn, useBackgroud: true },
    beta: { title: 'chemicalParameterScreen.titleBetaCard', subtitle: 'chemicalParameterScreen.messageBetaCard', testID: 'jala:id/create-cycle', button: 'chemicalParameterScreen.buttonBetaCard' as TxKeyPath, img: userLocale === 'id' ? imageBetaTesterId : imageBetaTesterEn, useBackgroud: true },
  }

  const styleContent = {
    nonPro: {
      paddingBottom: "16px"
    }
  }

  useEffect(() => {
    if (!farmStore || !farmStore.farm) setEmptyKey('farm')
    else if (!pondStoreModels.length) setEmptyKey('pond')
    else if (!(pondStore && pondStore.cycles && pondStore.cycles.length)) setEmptyKey('cycle')
    else if ((pondStoreModels.findIndex(item => item?.pond?.pro)) === -1 && !(pondStore && pondStore.pond && pondStore.pond.pro)) setEmptyKey('beta')
    else if (!(pondStore && pondStore.pond && pondStore.pond.pro)) setEmptyKey('nonPro')
    else if (!data.length) setEmptyKey('emptyHistory')
    else setEmptyKey('cycle')
  }, [data, farmStore, pondStore, pondStoreModels])

  const onNavigate = useCallback(() => {
    switch (emptyKey) {
      case 'farm':
        navigate('Home.Stack', 'Home.Farm.Create', { route: 'create' }); break;
      case 'pond':
        navigate('Home.Stack', 'Home.Pond.PreCreateMultiple'); break;
      case 'cycle':
        navigate('Home.Stack', 'Home.Cycle.CreateMultiple', { models: [{
          pond_id: pondStore.pond && pondStore.pond.id,
          area: pondStore.pond && pondStore.pond.area,
          deep: pondStore.pond && pondStore.pond.deep
        }] }); break;
      case 'nonPro': {
        JalaAnalytic.log('Mobile App : Chemical Prediction - View USP Pro');
        navigate('Home.Stack', 'Home.GotoJalaPro'); break;
      }
      case 'beta': {
        JalaAnalytic.log('Mobile App : Chemical Prediction - Apply Beta Tester');
        Linking.openURL("https://s.id/register-prediksi-kimia-mobile").catch();
        break;
      }
      case 'emptyHistory':
        JalaAnalytic.log('Mobile App : Chemical Prediction - Complete Data');
        navigate('App.Stack', 'Home.Home', { tabNavigation: true, action: "onOpenQuickInput" }); break;
    }
  }, [emptyKey, pondStore])

  return (
    <View {...rest}>
      <EmptyHistoryParameterState
        colorScheme={colorScheme}
        image={content[emptyKey].img}
        titleTx={content[emptyKey].title}
        messageTx={content[emptyKey].subtitle}
        buttonTx={content[emptyKey].button}
        withBackground={content[emptyKey].useBackgroud}
        onPressButton={onNavigate}
        {...styleContent[emptyKey]}
      />
    </View>
  )
})

export const WarningModal: FC<{colorScheme: "light" | "dark", isOpen: boolean, type: string, onNavigate: (type: string) => void} & IBoxProps> = (props) => {
  const {isOpen, onNavigate, type, colorScheme, ...restContentStyle} = props;
  const imageDefault = require("../activity/cycle-to-do-list/empty-search.png");

  const content = {
    emptyData: {withWarningIcon: false, withCloseButton: true, alertTitle: "chemicalParameterScreen.emptyDataTitle", alertMessage: "chemicalParameterScreen.emptyDataMessage", rightBtn: "chemicalParameterScreen.completeData"},
    lowAccuracyData: {withWarningIcon: true, withCloseButton: true, alertTitle: "chemicalParameterScreen.lowAccuracyTitle", alertMessage: "chemicalParameterScreen.lowAccuracyMessage", rightBtn: "chemicalParameterScreen.completeData"},
  }
  if (!type) {
    return null
  }
  return (
    <>
      <Modal
        backgroundColor={'rgba(27, 119, 223, 0.5)'}
        isOpen={isOpen}>
        <Modal.Content
          width="90%"
          paddingLeft="20px" paddingRight="20px"
          paddingTop="16px" paddingBottom="16px"
          justifyContent="center" alignItems={"center"}
          {...restContentStyle}
        >
          <Image source={imageDefault} style={IMAGE} />
          <View flexDirection="row" alignItems={"center"}>
            { type && content[type].withWarningIcon &&
              <Icon as={Ionicons} name="warning" size={"16px"} marginRight="6px" color={color.palette.orangeDarker} />
            }
            <Text colorScheme={colorScheme} preset="display3" tx={type && content[type].alertTitle} />
          </View>
          <Text colorScheme={colorScheme} marginTop="8px" preset="body2" textAlign="center" tx={type && content[type].alertMessage} />

          <View flexDirection={"row"}>
            {(type && content[type].withCloseButton) && <Button
              onPress={() => {
                onNavigate("")
              }}
              style={CLOSE_DATA_BUTTON} textPreset="title4"
              tx={"common.close"} preset="outline"
              colorScheme={colorScheme}
            />}
            <Button
              colorScheme={colorScheme}
              onPress={() => {
                onNavigate(type)
              }}
              style={OK_DATA_BUTTON} textPreset="title4"
              tx={type && content[type].rightBtn}
            />
          </View>
        </Modal.Content>
      </Modal>
    </>
  )
}

const DataTableChemical: FC<{colorScheme: "light" | "dark", item: any, onPressFullscreen?: () => void}> = observer((props) => {
  const {onPressFullscreen, item, colorScheme} = props
  const { chemicalParameterStore: { data : chemicalParameter }, appStore: { farmStore } } = useStores();
  const { pondStore } = farmStore || FarmStoreModel.create({});

  const cycleModels = useMemo(() => {
    return pondStore?.cycleStore?.cycle || {}
  }, [pondStore])

  return (
    <View>
      <View
        flexDirection={"row"} borderBottomWidth="1px"
        background={color.palette.lineLight} borderColor={color.palette.gray200}
        paddingY="8px" paddingX="12px"
      >
        <Text
          preset="title5" flex={1} colorScheme={colorScheme}
          tx="chemicalParameterScreen.parameter"
        />
        <Text
          textAlign={"center"}
          preset="title5" flex={1} colorScheme={colorScheme}
          tx={"chemicalParameterScreen.actualValueToday"}
          txOptions={{
            age: item?.latestActualAge || 0
          }}
        />
        <Text
          textAlign={"center"}
          preset="title5" flex={1} colorScheme={colorScheme}
          tx={cycleModels.finished_at ? "chemicalParameterScreen.estimateValueDoC" : "chemicalParameterScreen.estimateValueToday"}
          txOptions={{
            age: cycleModels?.age || 0
          }}
        />
      </View>
      { item.data && item.data.map((value, index) => {
        const itemChemicalParameter = chemicalParameter.find(parameter =>
          value.key === parameter.code
        ) || {}

        const nameText = itemChemicalParameter.code && itemChemicalParameter.code !== "alkalinity"
        && itemChemicalParameter.code !== "hardness" ?
        itemChemicalParameter.code === "tom" ? "TOM" : itemChemicalParameter.name_translated : translate("chemicalParameterScreen.total")

        const unitText = itemChemicalParameter.low_limit === 0 ? `< ${itemChemicalParameter.high_limit || ""} ${itemChemicalParameter.unit || ""}` :
        itemChemicalParameter.high_limit === 0 ?  `≥ ${itemChemicalParameter.low_limit || ""} ${itemChemicalParameter.unit || ""}` :
        `${itemChemicalParameter.low_limit || ""}-${itemChemicalParameter.high_limit || ""} ${itemChemicalParameter.unit || ""}`

        return (
          <View
            key={`key-item-table-${index}`}
            flexDirection={"row"} borderTopWidth="1px" borderBottomWidth="1px"
            borderColor={color.palette.gray200} paddingY="8px" paddingX="12px"
          >
            <View flex={1} flexDirection="row" alignItems="center">
              <Text
                preset="body3" colorScheme={colorScheme}
                text={nameText} paddingRight="6px"
              />
              <Text
                preset="body4" colorScheme={colorScheme}
                text={unitText} color={color.palette.blue500}
              />
            </View>
            <Text
              textAlign={"center"}
              preset="body3" flex={1} color={value.actualValue && value.actualValue <= parseFloat(itemChemicalParameter.high_limit)
                && value.actualValue > parseFloat(itemChemicalParameter.low_limit) || (value.actualValue === 0.0) ? color.palette.gray800 : color.palette.red600}
              text={value.actualValue !== 0.0 ? value.actualValue.toFixed(2) : '-'} paddingRight="6px" colorScheme={colorScheme}
            />
            <Text
              textAlign={"center"}
              preset="body3" flex={1} color={value.value && value.value <= parseFloat(itemChemicalParameter.high_limit)
                && value.value > parseFloat(itemChemicalParameter.low_limit) || (value.value === 0.0) ? color.palette.gray800 : color.palette.red600}
              text={value.value !== 0.0 ? value.value.toFixed(2) : '-'} paddingRight="6px" colorScheme={colorScheme}
            />
          </View>
        )
      })}

      {onPressFullscreen && <Button
        style={{
          height: 24, backgroundColor: "rgba(0, 0, 0, 0.35)",
          bottom: 8, right: 8, position: 'absolute'
        }}
        testID="jala:id/table-button" preset="link"
        onPress={onPressFullscreen}
      >
        <Icon
          as={<JalaIcon name={"fullscreen"} />} size={"24px"} margin="1px"
          color={color.palette.white}
        />
      </Button>}
    </View>
  )
})

export const AlertCompleteData: FC<{colorScheme: "light" | "dark", alertType: string, onPressDetail: (content: string) => void} & IViewProps> = (props) => {
  const { alertType, onPressDetail, colorScheme, ...restProps } = props
  const content = {
    emptyData: {message: "chemicalParameterScreen.emptyPredictionMessage", withWarningIcon: false, withCloseButton: true, alertTitle: "chemicalParameterScreen.emptyDataTitle", alertMessage: "chemicalParameterScreen.emptyDataMessage"},
    lowAccuracyData: {message: "chemicalParameterScreen.lowAccuracyPredictionMessage", withWarningIcon: true, withCloseButton: true, alertTitle: "chemicalParameterScreen.lowAccuracyTitle", alertMessage: "chemicalParameterScreen.lowAccuracyMessage"},
  }
  return (
    <View
      flexDirection="row"
      background={color.palette.orange300} paddingX="6px" paddingY="4px"
      {...restProps}>
      <Icon
        as={<JalaIcon name={"info-1"} />} size={"16px"} margin="0px"
        color={color.palette.gray800}
      />
      <View>
        <Text
          background={color.palette.red} colorScheme={colorScheme}
          preset="body3" paddingLeft="8px" paddingRight="8px" flex={1}
        >{translate(content[alertType].message).split(/(<.*?>.*?<\/.*?>)/g).map((value, index) => {
            if (value.match(/(<.*?>.*?<\/.*?>)/g)) {
              return <Text colorScheme={colorScheme} key={`key-alert-${index}`} preset="title5">{value.replace(/<.*?>|<\/.*?>/g, "")}</Text>
            }
            return value
          })}
          <Text colorScheme={colorScheme} onPress={() => onPressDetail(alertType)} color={color.palette.blue500} preset="title5" tx="chemicalParameterScreen.showDetail" />
        </Text>
      </View>
    </View>
  )
}

const AlertBetaUser: FC<{colorScheme: "light" | "dark"}> = (props) => {
  const {colorScheme} = props;
  const [isOpenModalExplanation, setOpenModalExplanation] = useState<boolean>(false)

  const onPressReadExplaination = useCallback(() => {
    setOpenModalExplanation(true)
    JalaAnalytic.log('Mobile App : Chemical Prediction - Read Explanation');
  }, [])
  const onPressSendFeedback = useCallback(() => {
    Linking.openURL("https://s.id/feedback-prediksi-kimia-mobileapp").catch()
    JalaAnalytic.log('Mobile App : Chemical Prediction - Give Feedback');
  }, [])

  const dimentions = useWindowDimensions();

  return (
    <>
      <View
        flexDirection="row"
        background={color.palette.orange300} paddingX="20px" paddingY="4px">
        <Icon
          as={<JalaIcon name={"info-1"} />} size={"16px"} margin="0px"
          color={color.palette.gray800}
        />
        <View>
          <Text
            background={color.palette.red} colorScheme={colorScheme}
            preset="body3" paddingLeft="8px" paddingRight="8px"
          >
            { translate('chemicalParameterScreen.alertBeta').split(/(<.*?>)/g).map((value, index) => {
              if (value.match(/(<description>)/g)) {
                return <Text
                  onPress={() => onPressReadExplaination()}
                  colorScheme={colorScheme}
                  key={`key-alert-beta-${index}`}
                  color={color.palette.blue500}
                  preset="title5" tx="chemicalParameterScreen.readDescription" />
              }
              if (value.match(/(<feedback>)/g)) {
                return <Text
                  onPress={() => onPressSendFeedback()}
                  colorScheme={colorScheme}
                  key={`key-alert-beta-${index}`}
                  color={color.palette.blue500}
                  preset="title5" tx="chemicalParameterScreen.sendFeedback" />
              }
              return value
            })}
          </Text>
        </View>
      </View>
      <Actionsheet
        isOpen={isOpenModalExplanation}
        colorScheme={colorScheme}
        actionsheetStyle={{
          minHeight: dimentions.height - 100
        }}
        onClose={() => setOpenModalExplanation(false)}
      >
        <View paddingX={"16px"} flex={1}>
          <View flexDirection={"row"} alignItems={"center"} alignSelf={"center"} marginBottom={"12px"} >
            <Text colorScheme={colorScheme} tx="chemicalParameterScreen.titleBetaSheet" preset="title3" />
            <BetaIcon marginLeft={"8px"} colorScheme={colorScheme} />
          </View>
          <ScrollView>
            <Text colorScheme={colorScheme} preset="body2" tx="chemicalParameterScreen.content1BetaSheet" />
            <Text marginTop={"12px"} colorScheme={colorScheme} preset="title4" tx="chemicalParameterScreen.subtitle1BetaSheet" />
            <View flexDirection={"row"}>
            { LIST_PARAMETER_BETA.map((listParameter, indexList) => {
              return (
                <View key={`key-${indexList}`} style={{flex: 1}}>
                  {
                    listParameter.map((parameter, index) => {
                      return (
                        <View key={`key-parameter-${index}`} flex={1} flexDirection={"row"} alignItems={"center"} marginTop={"2px"}>
                          {parameter && <Icon as={Ionicons} name="ellipse" size={"6px"} marginRight="6px" color={color.palette.black} />}
                          <Text preset="body2" colorScheme={colorScheme} marginLeft={"2px"} tx={parameter} />
                        </View>
                      )
                    })
                  }
                </View>
              )
            })}
            </View>
            <Text marginTop={"12px"} colorScheme={colorScheme} preset="title4" tx="chemicalParameterScreen.subtitle2BetaSheet" />
            <Text marginTop={"0px"} colorScheme={colorScheme} preset="body2" tx="chemicalParameterScreen.content2BetaSheet" />
            <Text marginTop={"12px"} colorScheme={colorScheme} preset="title4" tx="chemicalParameterScreen.subtitle3BetaSheet" />
            <Text marginTop={"0px"} colorScheme={colorScheme} preset="body2" tx="chemicalParameterScreen.content3BetaSheet" />

            <View marginTop={"12px"} padding={"8px"} backgroundColor={color.palette.orange300}>
              <Text colorScheme={colorScheme} preset="body2" tx="chemicalParameterScreen.note1BetaSheet" />
              <Text marginTop={"12px"} colorScheme={colorScheme} preset="body2">
                {translate("chemicalParameterScreen.note2BetaSheet").split(/(<.*?>.*?<\/.*?>)/g).map((value, index) => {
                  if (value.match(/(<.*?>.*?<\/.*?>)/g)) {
                    return <Text colorScheme={colorScheme} key={`key-alert-${index}`} preset="title4">{value.replace(/<.*?>|<\/.*?>/g, "")}</Text>
                  }
                  return value
                })}
              </Text>
            </View>
          </ScrollView>
          <Button onPress={onPressSendFeedback} style={{marginTop: 12}} colorScheme={colorScheme} preset="primary" tx="chemicalParameterScreen.sendFeedback" />
        </View>
      </Actionsheet>
    </>
  )
}

export const GraphChemical: FC<{
  colorScheme: "light" | "dark",
  item: any, withTitle: boolean,
  onPressFullscreen?: (filter: 'week' | 'month' | 'cycle') => void,
  startCycle: string, finishCycle: string, isFinishedCycle: boolean,
  filter?: 'week' | 'month' | 'cycle', onSetFilter: (filter: 'week' | 'month' | 'cycle') => void,
  filterContainerStyle?: IViewProps
}> = (props) => {
  const {
    withTitle, item, onPressFullscreen,
    startCycle, finishCycle,
    filter: filterProps, filterContainerStyle,
    colorScheme, isFinishedCycle, onSetFilter
  } = props
  const [filter, setFilter] = useState<'week' | 'month' | 'cycle'>(filterProps || "week");
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const dimentions = useWindowDimensions();

  const onError = useCallback(() => setError(true), [])
  const onFinishLoading = useCallback(() => setLoading(false), [])

  const url = useMemo(() => {
    let afterDate: string
    let beforeDate: string
    switch(filter) {
      case "week": {
        afterDate = isFinishedCycle ? moment(finishCycle).add(-7, 'days').format("YYYY-MM-DD") : moment().add(-7, 'days').format("YYYY-MM-DD")
        beforeDate = isFinishedCycle ? finishCycle : moment().format("YYYY-MM-DD")
        break;
      }
      case "month": {
        afterDate = isFinishedCycle ? moment(finishCycle).add(-30, 'days').format("YYYY-MM-DD") : moment().add(-30, "days").format("YYYY-MM-DD")
        beforeDate = isFinishedCycle ? finishCycle : moment().format("YYYY-MM-DD")
        break;
      }
      default: {
        afterDate = startCycle
        beforeDate = finishCycle
      }
    }
    return `${item.url}&after=${afterDate}&before=${beforeDate}`
  }, [filter, item.url, isFinishedCycle, finishCycle, startCycle])

  return (
    <View
      {...withTitle ? {borderTopWidth: "1px", borderColor: color.palette.gray200} : {} }
    >
      {withTitle && <Text
        preset="title4" paddingX="16px" paddingTop="12px" text={item.parameter.name_translated}
        colorScheme={colorScheme}
      />}
      <View
        marginTop="12px" marginBottom="20px"
        background={color.palette.gray200} borderRadius="5px" height="30px"
        flexDirection="row" justifyItems="center" alignItems="center" alignSelf="center"
        {...filterContainerStyle}
      >
        <TouchableOpacity
          style={{
            backgroundColor: filter === "week" ? color.palette.white : undefined,
            height: 28,
            marginHorizontal: 1,
            borderRadius: 5,
            justifyContent:"center",
          }}
          onPress={() => {
            setFilter("week")
            onSetFilter("week")
          }}
        >
          <Text
            preset="title5" paddingX="12px"
            tx="chemicalParameterScreen.week"
            colorScheme={colorScheme}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={{
            backgroundColor: filter === "month" ? color.palette.white : undefined,
            height: 28,
            marginHorizontal: 1,
            borderRadius: 5,
            justifyContent:"center",
          }}
          onPress={() => {
            setFilter("month")
            onSetFilter("month")
          }}
        >
          <Text
            preset="title5" paddingX="12px"
            tx="chemicalParameterScreen.month"
            colorScheme={colorScheme}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={{
            backgroundColor: filter === "cycle" ? color.palette.white : undefined,
            height: 28,
            marginHorizontal: 1,
            borderRadius: 5,
            justifyContent:"center",
          }}
          onPress={() => {
            setFilter("cycle")
            onSetFilter("cycle")
          }}
        >
          <Text
            preset="title5" paddingX="12px"
            tx="chemicalParameterScreen.cycle"
            colorScheme={colorScheme}
          />
        </TouchableOpacity>
      </View>
      <View
        flex={1} minHeight="273px"
        background={color.palette.white}
      >
        { error &&
          <ListNetworkError
            marginTop="16px"
            marginLeft="16px"
            marginRight="16px"
            height={`273px`}
            backgroundColor={color.palette.white}
            borderRadius="4px"
            imageStyles={IMAGE_NETWORK_ERROR}
            onRefresh={() => {
              setError(false)
            }}
          />
        }
        {!error && <JalaWebView
          source={{uri: url}}
          style={{
            height: 273,
            marginBottom: 10,
            backgroundColor: color.palette.white
          }}
          onHttpError={onError}
          onError={onError}
          onLoad={onFinishLoading}
          nestedScrollEnabled={true}
          startInLoadingState
        />}
        <View
          position={"absolute"}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            bottom: 77, position: 'absolute', width: dimentions.width*0.15,
            top: 0, right: 0,
          }}
        />
        <View
          position={"absolute"}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            bottom: 77, position: 'absolute', width: dimentions.width*0.15,
            top: 0, left: 0,
          }}
        />
        { (onPressFullscreen && !error && !loading) &&
          <Button
            style={{
              height: 24, backgroundColor: "rgba(0, 0, 0, 0.35)",
              bottom: 100, right: 25, position: 'absolute'
            }}
            testID="jala:id/table-button" preset="link"
            onPress={() => onPressFullscreen(filter)}
            colorScheme={colorScheme}
          >
            <Icon
              as={<JalaIcon name={"fullscreen"} />} size={"24px"} margin="1px"
              color={color.palette.white}
            />
          </Button>
        }
      </View>
    </View>
  )
}

const ItemChemical: FC<{
  colorScheme: "light" | "dark",
  item: any, lastMeasurement: any,
  showLowAccuracyAlert: boolean,
  onPressAlertModal: (content: string) => void,
  onPressFullscreen: (item: any, type: 'graph' | 'table', filter: 'week' | 'month' | 'cycle') => void,
  startCycle: string, finishCycle: string, cycleId: number, isFinishedCycle: boolean,
}> = (props) => {
  const {
    colorScheme,
    item,
    onPressFullscreen,
    showLowAccuracyAlert,
    onPressAlertModal,
    startCycle, finishCycle, cycleId,
    isFinishedCycle,
    lastMeasurement,
  } = props
  const [isTableShown, setIsTableShown] = useState<boolean>(true)
  const [filter, setFilter] = useState<'week' | 'month' | 'cycle'>('week')
  const { BASE_URL } = config();
  const { chemicalParameterStore: { data : chemicalParameter } } = useStores();

  const sourceUrls = useMemo(() => {
    const parameterCode = []
    if (item.title === "chemicalParameterScreen.alkalinity") {
      parameterCode.push("alkalinity")
    } else if (item.title === "chemicalParameterScreen.hardness") {
      parameterCode.push("hardness")
    } else {
      parameterCode.push(...["ammonia", "nitrit", "nitrat", "tom"])
    }

    return parameterCode.map(value => {
      const parameter = chemicalParameter.find(parameter =>
        parameter.code === value
      ) || {}

      let url = `${BASE_URL}/web_view/cycles/${cycleId}/measurement_prediction_charts?`
      url += `parameter_code=${value}`
      return {
        url,
        parameter
      }
    })
  }, [item, chemicalParameter, BASE_URL, cycleId]);

  useEffect(() => {
    if (isTableShown) {
      JalaAnalytic.log("Mobile App : Chemical Prediction - Visit Table Prediction", {
        title: item.title.replace("chemicalParameterScreen.", "")
      })
    } else {
      JalaAnalytic.log("Mobile App : Chemical Prediction - Visit Graphic Prediction", {
        title: item.title.replace("chemicalParameterScreen.", ""),
        filter,
      })
    }
  }, [filter, isTableShown, item.title])

  return (
    <View
      backgroundColor={color.palette.white} flex={1}
      shadow={1} borderRadius="4px"
      marginTop="14px" marginX="10px"
    >
      <View
        alignItems="center" borderBottomWidth="1px" borderColor={color.palette.gray200}
        flexDirection={"row"} paddingX="16px" paddingY="12px"
      >
        <View>
          <Text colorScheme={colorScheme} tx={item.title} preset="title3" />
          <Text colorScheme={colorScheme} tx="chemicalParameterScreen.latestUpdateText" txOptions={{date: `${
            lastMeasurement ? moment(lastMeasurement.measured_date).format("DD MMM YYYY") + ` (DoC ${lastMeasurement.age})` : '-'
            }`}} preset="body3" />
        </View>
        <View flex={1} />
        <Button
          style={{
            height: 30,
            marginLeft: 12,
            borderWidth: 1.5,
            borderColor: !isTableShown ? color.palette.blueJalaBase : color.palette.lineDark
          }}
          testID="jala:id/graph-button" preset="link"
          onPress={() => {setIsTableShown(false)}}
        >
          <Icon
            as={<Octicons name="graph" />} margin={"2px"} size={"24px"}
            color={!isTableShown ? color.palette.blueJalaBase : color.palette.lineDark}
          />
        </Button>
        <Button
          style={{
            height: 30,
            marginLeft: 12,
            borderWidth: 1.5,
            borderColor: isTableShown ? color.palette.blueJalaBase : color.palette.lineDark
          }}
          testID="jala:id/table-button" preset="link"
          onPress={() => {setIsTableShown(true)}}
        >
          <Icon
            as={<MaterialCommunityIcons name="table-large" />} margin={"2px"} size={"24px"}
            color={isTableShown ? color.palette.blueJalaBase : color.palette.lineDark}
          />
        </Button>
      </View>
      { ((showLowAccuracyAlert || item.isEmpty) && !isFinishedCycle) &&
        <AlertCompleteData
          colorScheme={colorScheme} marginBottom="8px"
          alertType={item.isEmpty ? "emptyData" : "lowAccuracyData"}
          onPressDetail={onPressAlertModal}
        />
      }
      <View>
        {
          isTableShown ?
          <DataTableChemical colorScheme={colorScheme} item={item} onPressFullscreen={() => onPressFullscreen(item, "table", 'cycle')} />
          :
          sourceUrls.map((url, index) => <GraphChemical
            colorScheme={colorScheme}
            key={`item-graph-${index}`}
            item={url} startCycle={startCycle} finishCycle={finishCycle}
            isFinishedCycle={isFinishedCycle}
            withTitle={sourceUrls.length > 1}
            onSetFilter={(filter) => {
              setFilter(filter)
            }}
            onPressFullscreen={(filter) => onPressFullscreen(item, "graph", filter)} />)
        }
      </View>
    </View>
  )
}

export const ChemicalMeasurementPredictionListScreen: FC<{ colorScheme: "light" | "dark" }> = observer(function ChemicalParameterScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;

  // Pull in one of our MST stores
  const {
    appStore, appStore: { farmId, farmStore },
    feedStore, chemicalParameterStore, chemicalPredictionsStore,
    chemicalMultiMeasurementStore: actualChemicalModelStore
  } = useStores();
  const {
    initiating, pondStore, pondId, loadingPond, loadingCycle, waterQualityMultiMeasurements,
    chemicalMultiMeasurements,
  } = farmStore || FarmStoreModel.create({});

  const {
    cycleId,
    cycleStore
  } = pondStore || PondStoreModel.create({});

  const [isShowContentModal, setShowContentModal] = useState<boolean>(false);
  const [typeModal, setTypeModal] = useState<string>(null);

  useEffect(() => {
    if (chemicalParameterStore) chemicalParameterStore.init()
    if (chemicalPredictionsStore) chemicalPredictionsStore.init()
    if (actualChemicalModelStore) actualChemicalModelStore.init()
  },[chemicalParameterStore, chemicalPredictionsStore, actualChemicalModelStore]);

  useEffect(() => {
    feedStore?.init();
    farmStore?.getStocks(false);
    cycleStore?.getFastings(true, () => {
      cycleStore.getFeeds();
    });
    if (pondStore) {
      pondStore.init();
      cycleStore?.getWaterQualityMultiMeasurements();
      cycleStore?.getChemicalMultiMeasurements(true);
    }
  }, [cycleStore, farmStore, feedStore, pondStore])

  useEffect(() => {
    chemicalPredictionsStore.reset()
    chemicalParameterStore.getChemicalParameter()
  }, [chemicalParameterStore, chemicalPredictionsStore]);

  const onCallChemicalPredictions = useCallback((page: number) => {
    const cycleModel = pondStore?.cycleStore?.cycle || {}

    if (pondStore && pondStore.pond.pro && cycleModel.started_at) {
      const endDate = cycleModel.finished_at || moment().format('YYYY-MM-DD');
      chemicalPredictionsStore.getChemicalPredictions(
        cycleModel.id,
        `${cycleModel.started_at || moment().format('YYYY-MM-DD')},${endDate}`,
        page
      )
    }
  }, [pondStore, chemicalPredictionsStore])

  useEffect(() => {
    onCallChemicalPredictions(1)
  }, [cycleId, onCallChemicalPredictions]);

  useEffect(() => {
    if (chemicalPredictionsStore.nextPage > 1) {
      onCallChemicalPredictions(chemicalPredictionsStore.nextPage)
    }
  }, [onCallChemicalPredictions, chemicalPredictionsStore.nextPage]);

  useEffect(() => {
    chemicalPredictionsStore.getListParametersPredictions(pondStore?.cycleStore?.cycle || {}, chemicalMultiMeasurements)
  }, [chemicalPredictionsStore.loading, chemicalPredictionsStore.data.length, chemicalMultiMeasurements, pondStore, chemicalMultiMeasurements.length, chemicalPredictionsStore])
  
  const getChemicalParameter = useCallback(() => {
    chemicalParameterStore.getChemicalParameter()
  }, [chemicalParameterStore]);

  const onRefresh = useCallback(() => {
    chemicalParameterStore.getChemicalParameter()
    chemicalPredictionsStore.reset()
    onCallChemicalPredictions(1)
  }, [chemicalParameterStore, chemicalPredictionsStore, onCallChemicalPredictions])

  const onFarmChange = useCallback(async (value) => {
    appStore.set('farmId', value || null)
    await delay(1)
    if (appStore.farmStore) {
      appStore.farmStore.initWithLastBatchAndWaterQualityMultiMeasurements()
      getChemicalParameter()
    }
    chemicalPredictionsStore.reset()
  }, [appStore, chemicalPredictionsStore, getChemicalParameter]);

  const onPondChange = useCallback(async (value) => {
    farmStore.set('pondId', value || null);
    await delay(1);
    if (farmStore) farmStore.initWithLastBatchAndWaterQualityMultiMeasurements();
    chemicalPredictionsStore.reset()
  }, [chemicalPredictionsStore, farmStore])

  const onCycleChange = useCallback(async (value) => {
    pondStore.set('cycleId', value);
    await delay(1);
    if (pondStore.cycleId) {
      pondStore.init();
      cycleStore?.getWaterQualityMultiMeasurements();
    }
    chemicalPredictionsStore.reset()
  }, [chemicalPredictionsStore, cycleStore, pondStore])

  const onPressAlertModal = useCallback((content: string) => {
    setTypeModal(content)
    setShowContentModal(true)
  }, []);

  const onPressFullscreen = useCallback((item: any, type: 'graph' | 'table', filter: 'week' | 'month' | 'cycle') => {
    JalaAnalytic.log("Mobile App : Chemical Prediction - Landscape View")
    navigate('Home.ChemicalMeasurementPrediction.Stack', "Home.ChemicalMeasurementPrediction.Detail", {
      title: item.title,
      type: type,
      filter: filter,
      onPressAlertWarning: onPressAlertModal
    })
  }, [onPressAlertModal]);

  const onPressNavigateModal = useCallback((type: string) => {
    if (type === "emptyData") {
      JalaAnalytic.log('Mobile App : Chemical Prediction - Complete Data');
      navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.WaterQualityMultiMeasurement.List' });
    }
    setShowContentModal(false)
    setTypeModal(null)
  }, [])

  const isShowLowAccuracyAlert = useMemo(() => {
    const startDay = moment().add(-4, 'days');
    const endDay = moment();

    let startingDay = startDay;
    let emptyMeasurement = 0;
    const filteredData = waterQualityMultiMeasurements.filter(value => value.cycle_id === cycleId)

    while(startingDay <= endDay) {
      const waterMeasurementItem = filteredData.find(value => value.measured_date === startingDay.format("YYYY-MM-DD"));
      const feedItem = cycleStore && cycleStore.feedsPerDate.find(value => value.feed_at === startingDay.format("YYYY-MM-DD"));
      
      if (!waterMeasurementItem && !feedItem) {
        emptyMeasurement += 1
      }
      startingDay = startingDay.add(1, 'days');
    }

    return emptyMeasurement > 1
  }, [waterQualityMultiMeasurements, cycleId, cycleStore]);

  const lastMeasurement = useMemo(() => {
    return _(waterQualityMultiMeasurements.filter(value => value.cycle_id === cycleId)).maxBy('measured_date');
  }, [waterQualityMultiMeasurements, cycleId])

  const renderItem: ListRenderItem<any> = useCallback(({ item }) => {
    const cycleModel = pondStore?.cycleStore?.cycle || {}

    return (
      <ItemChemical
        colorScheme={colorScheme} item={item}
        lastMeasurement={lastMeasurement}
        showLowAccuracyAlert={false}
        onPressFullscreen={onPressFullscreen}
        onPressAlertModal={onPressAlertModal} cycleId={cycleId}
        isFinishedCycle={!!cycleModel.finished_at}
        startCycle={moment(cycleModel.started_at || moment().format('YYYY-MM-DD')).format("YYYY-MM-DD")}
        finishCycle={moment(cycleModel.finished_at || moment().format('YYYY-MM-DD')).format("YYYY-MM-DD")}
      />
    )
  }, [pondStore, colorScheme, onPressFullscreen, onPressAlertModal, cycleId, lastMeasurement])

  const renderSelectedItem = useCallback((item) => (
    <View flexDirection="row" alignItems="center">
      {(item && item.pro) && <Icon marginLeft="6px" marginRight="2px" as={JalaIcon} name="premium-1" size="16px" color={color.palette.orange500} />}
      <Text
        colorScheme={colorScheme}
        marginLeft={!(item && item.pro) ? "8px" : "0px"}
        preset={"body2"}
        text={item ? item.name : translate("cycleForm.pondIdPlaceholder")}
        color={item ? color.text : color.palette.gray500}
      />
    </View>
  ), [colorScheme])

  const renderItemTextPond = useCallback((item) => (
    <View flexDirection="row" alignItems="center">
      {item.pro && <Icon marginRight="10px" as={JalaIcon} name="premium-1" size="20px" color={color.palette.orange500} />}
      <Text colorScheme={colorScheme} preset={pondId === item.id ? "title4" : "body2"} text={item.name} />
    </View>
  ), [colorScheme, pondId])

  const isLoading = chemicalParameterStore.loading || chemicalPredictionsStore.loading || loadingPond || loadingCycle || initiating;
  const { height } = useWindowDimensions();

  return (
    <Screen
      style={ROOT}
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      hideOnBlurred={false}
      backgroundColor={colorScheme === "light" ? color.palette.backgroundGray : undefined}
    >
      <AlertBetaUser
        colorScheme={colorScheme}
      />
      <FlatList
        data={isLoading || chemicalPredictionsStore.data.length === 0 ? [] : chemicalPredictionsStore.listParameterPredictions}
        keyExtractor={(_, index) => `key-item-prediction-${index}`}
        ListEmptyComponent={isLoading ? (
          <View flexGrow={1} alignItems="center" justifyContent="center" height={`${height - 324}px`}>
            <JalaLoading />
          </View>
        ) : <EmptyState colorScheme={colorScheme} />}
        renderItem={renderItem}
        refreshControl={
          <RefreshControl refreshing={false} onRefresh={onRefresh} />
        }
        ListHeaderComponent={
          <View
            background={colorScheme === "light" ? color.palette.white : undefined}
            shadow={1} zIndex={100}
          >
            <ModelField
              colorScheme={colorScheme}
              name='farm_id'
              modelPickerProps={{
                Model: Farm,
                value: farmId,
                onValueChange: onFarmChange,
                isDisabled: initiating,
                InputRightElement: initiating && <Spinner mr="9px"></Spinner>,
                titleTx: "cycleForm.farmIdPlaceholder",
                isUseSearch: true,
              }}
            />
            <View style={POND_CONTAINER}>
              <FormControl
                colorScheme={colorScheme}
                labelTx="waterQualityMultiMeasurementForm.pondId"
                style={FORM_DROPDOWN}
                flex={1}
                isDisabled={!farmId}
              >
                <ModelField
                  key={`${farmId}-${pondStore && pondStore.pond ? pondStore.pond.pro : 0}-pond_id`}
                  colorScheme={colorScheme}
                  name="pond_id"
                  formControlProps={{ labelTx: undefined, isDisabled: !pondId, padding: 0 }}
                  modelPickerProps={{
                    Model: Pond,
                    dataLabel: "name",
                    dataKey: "id",
                    fetchData: (model, search) => (
                      Promise.resolve(_.orderBy(
                        farmStore.pondStoreModels.map(pondStore => pondStore.pond)
                      )).then((models) => models.filter((m) => (
                        `${m.name}`
                      ).toLowerCase().includes((search || '').toLowerCase()))).then(m =>
                        m.sort((a, b) => {
                          return (a.pro && !b.pro) ? -1 : 0
                        })
                      )
                    ),
                    renderItemText: renderItemTextPond,
                    renderSelectedItem: renderSelectedItem,
                    value: !!pondId && (pondId || null),
                    isDisabled: (initiating || !farmId),
                    onValueChange: onPondChange,
                    titleTx: "cycleForm.pondIdPlaceholder",
                    placeholderTx: 'cycleForm.pondIdPlaceholder',
                    InputRightElement: initiating && <Spinner mr="9px"></Spinner>,
                    isUseSearch: true
                  }}
                />
              </FormControl>
              <ModelField
                key={`${farmId}-${pondStore && pondStore.pond ? pondStore.pond.pro : 0}-${pondId}-cycle_id`}
                colorScheme={colorScheme}
                name="cycle_id"
                formControlProps={{ flex: 1, labelTx: 'cycle', isDisabled: !pondId }}
                modelPickerProps={{
                  Model: Cycle,
                  dataLabel: "started_at",
                  fetchData: (model, search) => (
                    model.fetch({
                      pond_id__eq: pondId,
                      sort: 'started_at,desc|pond_name_alpha_numeric'
                    }).then((models) => models.filter((m) => (
                      `${moment(m.started_at).format("DD MMM YYYY")}${m.finished_at ? ` (${translate("Finished")})` : ""}`
                    ).toLowerCase().includes(search.toLowerCase())))
                  ),
                  renderItemText: (item) => item && `${moment(item.started_at).format("DD MMM YYYY")}${item.finished_at ? ` (${translate("Finished")})` : ""}`,
                  renderSelectedItemText: (item) => item && `${moment(item.started_at).format("DD MMM YYYY")}`,
                  value: cycleId && (cycleId || null),
                  isDisabled: (initiating || !pondId),
                  onValueChange: onCycleChange,
                  titleTx: "cycleForm.idPlaceholder",
                  placeholderTx: 'cycleForm.idPlaceholder',
                  InputRightElement: initiating && <Spinner mr="9px"></Spinner>
                }}
              />
            </View>
          </View>
        }
      />
      <WarningModal
        isOpen={isShowContentModal}
        onNavigate={onPressNavigateModal}
        type={typeModal}
        colorScheme={colorScheme}
      />
    </Screen>
  )
})
